import { getStoreApiUrl } from "../helpers/api";
import { uniq } from "lodash";
export const state = () => ({
  menuLoading: false,
  menuItems: [],
  groupedMenuItems: [],
  menuItem: {},
  categories: [],
  taxes: [],
  tags: [],
  addons: [],
  otherCharges: [{ label: "Package Charge", value: "package_charge" }],
  syncStatus: [],
  sortOrder: "alphabetical-order",
  brandFilter: "all-brands",
  searchBy: "",
  selectedGroupBy: "",
  selectedGroupByItem: "",
  selectedGroupBySubItem: "",
  combosList: [],
  comboDetail: {},
  menuUploadRawData: [],
  menuUploadList: [],
  menuUploadFieldMap: [],
  menuUploadCurrentStep: 0,
  menuUploadDragSelection: [],
  menuUploadDebounceTimer: null,
  menuUploadInvalidList: [],
  menuUploadDuplicateList: [],
  menuUploadMissingNameList: [],
  menuUploadExceededCharLimitList: [],
  menuBulkEditSelection: [],
  menuUploadImageList: [],
  menuUploadConfigureChargesFilters: {
    withVariants: true,
    withoutVariants: true,
    withPackagingCharges: true,
    withoutPackagingCharges: true
  },
  menuUploadGridFilters: {
    displayWithout: true,
    displayWith: true,
    categorizedView: true,
    isImageView: false
  }
});

export const mutations = {
  SET_CONFIGURE_CHARGES_FILTERS(state, filters) {
    state.menuUploadConfigureChargesFilters = { ...filters };
  },

  ADD_IMAGE_TO_LIST(state, { itemId, image }) {
    const imageIndex = state.menuUploadImageList.findIndex(
      (el) => el.itemId == itemId
    );
    if (imageIndex >= 0) {
      state.menuUploadImageList[imageIndex].image = image;
    } else {
      state.menuUploadImageList.push({ itemId, image });
    }
  },
  ADD_IMAGES_TO_LIST(state, images) {
    state.menuUploadImageList.push(...images);
  },
  ADD_UPLOADED_IMAGE_URL_TO_MENU_LIST(state, { itemId, image }) {
    const itemIndex = state.menuUploadList.findIndex((el) => el.id == itemId);
    state.menuUploadList[itemIndex].image = image;
  },
  REMOVE_UNASSIGNED_IMAGES(state) {
    state.menuUploadImageList = state.menuUploadImageList.filter(
      (el) => el.itemId
    );
  },
  UPDATE_IMAGE_UPLOAD_LIST_ITEM(state, { item, index }) {
    if (item.image) {
      state.menuUploadImageList[index] = item;
    } else {
      state.menuUploadImageList[index].itemId = item.itemId;
    }
    // Adding the below dummy action to make the file list reactive
    state.menuUploadImageList.push({ image: null, itemId: null });
    state.menuUploadImageList.pop();
  },
  DELETE_IMAGE_BY_ITEM_ID(state, itemId) {
    const imageIndex = state.menuUploadImageList.findIndex(
      (el) => el.itemId == itemId
    );
    state.menuUploadImageList.splice(imageIndex, 1);
  },
  DELETE_IMAGE_BY_INDEX(state, index) {
    state.menuUploadImageList.splice(index, 1);
  },
  MAP_CHOICE_TO_ITEM(state, { itemId, choiceInfo }) {
    const itemIndex = state.menuUploadList.findIndex((el) => el.id == itemId);
    state.menuUploadList[itemIndex].choices = [
      ...(state.menuUploadList[itemIndex].choices || []),
      choiceInfo
    ];
    state.menuUploadList = JSON.parse(JSON.stringify(state.menuUploadList));
  },
  UPDATE_CHOICE_GROUP(state, { itemId, choiceIndex, choiceInfos }) {
    const itemIndex = state.menuUploadList.findIndex((el) => el.id == itemId);
    state.menuUploadList[itemIndex].choices[choiceIndex] = choiceInfos;
    state.menuUploadList = JSON.parse(JSON.stringify(state.menuUploadList));
  },
  DELETE_CHOICE_GROUP({ menuUploadList }, { itemId, index }) {
    const itemIndex = menuUploadList.findIndex((el) => el.id == itemId);
    menuUploadList[itemIndex].choices.splice(index, 1);
  },
  MAP_ADDON_TO_ITEM(state, { itemId, addonInfo }) {
    const itemIndex = state.menuUploadList.findIndex((el) => el.id == itemId);
    state.menuUploadList[itemIndex].addons = [
      ...(state.menuUploadList[itemIndex].addons || []),
      addonInfo
    ];
    state.menuUploadList = JSON.parse(JSON.stringify(state.menuUploadList));
  },
  UPDATE_ADDON_GROUP(state, { itemId, addonIndex, addonInfos }) {
    const itemIndex = state.menuUploadList.findIndex((el) => el.id == itemId);
    state.menuUploadList[itemIndex].addons[addonIndex] = addonInfos;
    state.menuUploadList = JSON.parse(JSON.stringify(state.menuUploadList));
  },
  DELETE_ADDON_GROUP({ menuUploadList }, { itemId, index }) {
    const itemIndex = menuUploadList.findIndex((el) => el.id == itemId);
    menuUploadList[itemIndex].addons.splice(index, 1);
  },
  DELETE_ADDON({ menuUploadList }, addonId) {
    menuUploadList.forEach((item) => {
      item.addons?.forEach((addon) => {
        const index = addon.selectedItems.findIndex((id) => id === addonId);
        if (index >= 0) {
          addon.selectedItems.splice(index, 1);
        }
      });
    });
  },
  SET_MENU_LOADING(state, menuLoading) {
    state.menuLoading = menuLoading;
  },
  SET_MENU_ITEMS(state, menuItems) {
    state.menuItems = menuItems;
  },
  SET_MENU_ITEM(state, menuItem) {
    state.menuItem = menuItem;
  },
  SET_MENU_ITEM_IN_LIST(state, menuItem) {
    const index = state.menuItems.findIndex((el) => el.id == menuItem.id);
    state.menuItems[index] = menuItem;
    state.menuItems = JSON.parse(JSON.stringify(state.menuItems));
  },
  SET_CATEGORIES(state, categories) {
    state.categories = categories;
  },
  SET_TAXES(state, taxes) {
    state.taxes = taxes;
  },
  SET_TAGS(state, tags) {
    state.tags = tags;
  },
  SET_ADDONS(state, addons) {
    state.addons = addons;
  },
  ADD_ADDONS(state, addon) {
    state.addons.push(addon);
  },
  REMOVE_MENU_ITEM(state, id) {
    const index = state.menuItems.findIndex((el) => el.id == id);
    if (index >= 0) {
      state.menuItems.splice(index, 1);
    }
  },
  SET_MENU_ITEM_ACTIVE_STATUS(state, { itemId, variantId, status }) {
    const index = state.menuItems.findIndex((el) => el.id == itemId);
    if (index >= 0) {
      let menuItem = state.menuItems[index];
      if (variantId) {
        const variantIndex = menuItem.variants.items.findIndex(
          (el) => el.id == variantId
        );
        menuItem.variants.items[variantIndex].is_active = status;
        menuItem.variants.items[variantIndex].pending_availability_sync = true;
      } else {
        menuItem.item_is_active = status;
        menuItem.pending_availability_sync = true;
      }
      // state.menuItems.splice(index, 1);
      // state.menuItems.splice(index, 0, menuItem);
      state.menuItems[index] = menuItem;
    }
  },
  SET_SYNC_STATUS(state, syncStatus) {
    state.syncStatus = syncStatus;
  },
  SET_SORT_ORDER(state, sortOrder) {
    state.sortOrder = sortOrder;
  },
  SET_BRAND_FILTER(state, brandFilter) {
    state.brandFilter = brandFilter;
  },
  SET_SEARCH_BY(state, searchBy) {
    state.searchBy = searchBy;
  },
  SET_SELECTED_GROUP_BY_MENU(state, selectedGroupBy) {
    state.selectedGroupBy = selectedGroupBy;
  },
  SET_SELECTED_GROUP_BY_ITEM(state, selectedGroupByItem) {
    state.selectedGroupByItem = selectedGroupByItem;
  },
  SET_SELECTED_GROUP_BY_SUB_ITEM(state, selectedGroupBySubItem) {
    state.selectedGroupBySubItem = selectedGroupBySubItem;
  },
  SET_COMBOS_LIST(state, combosList) {
    state.combosList = combosList;
  },
  SET_COMBOS_DETAIL(state, comboDetail) {
    state.comboDetail = comboDetail;
  },
  SET_MENU_UPLOAD_RAW_DATA(state, menuUploadRawData) {
    state.menuUploadRawData = menuUploadRawData;
  },
  SET_MENU_UPLOAD_IMAGES(state, images) {
    state.menuUploadImageList = images;
  },
  SET_MENU_UPLOAD_LIST(state, menuUploadList) {
    state.menuUploadList = menuUploadList;
  },
  SET_MENU_UPLOAD_FIELD_MAP(state, menuUploadFieldMap) {
    state.menuUploadFieldMap = menuUploadFieldMap;
  },
  SET_MENU_UPLOAD_LIST_PROP(
    state,
    { ids, propName, propValue, subPropName, subPropValue }
  ) {
    state.menuUploadList.forEach((element, index) => {
      if (ids.includes(element.id)) {
        state.menuUploadList[index][propName] = propValue;
        if (propName !== "dish_type") {
          if (subPropValue) {
            state.menuUploadList[index][subPropName] = subPropValue;
          } else {
            state.menuUploadList[index].sub_category_id = null;
          }
        }
      }
    });
    mutations.SET_MENU_UPLOAD_DRAG_SELECTION(state, []);
    state.menuUploadList = JSON.parse(JSON.stringify(state.menuUploadList));
  },
  SET_MENU_UPLOAD_LIST_SINGLE_ITEM_PROP(state, { index, propName, propValue }) {
    clearTimeout(state.menuUploadDebounceTimer);
    state.menuUploadList[index][propName] = propValue;
    state.menuUploadDebounceTimer = setTimeout(
      (() => {
        this.dispatch("menu/resetMenuUploadList");
      }).bind(this),
      100
    );
  },
  RESET_MENU_UPLOAD_LIST(state) {
    state.menuUploadList = JSON.parse(JSON.stringify(state.menuUploadList));
  },
  SET_MENU_UPLOAD_DRAG_SELECTION(state, menuUploadDragSelection) {
    state.menuUploadDragSelection = uniq(menuUploadDragSelection);
  },
  SET_MENU_UPLOAD_CURRENT_STEP(state, menuUploadCurrentStep) {
    state.menuUploadCurrentStep = menuUploadCurrentStep;
  },
  SET_MENU_UPLOAD_INVALID_LIST(state, menuUploadInvalidList) {
    state.menuUploadInvalidList = menuUploadInvalidList;
  },
  SET_MENU_UPLOAD_DUPLICATE_LIST(state, menuUploadDuplicateList) {
    state.menuUploadDuplicateList = menuUploadDuplicateList;
  },
  SET_MENU_UPLOAD_MISSING_NAME_LIST(state, menuUploadMissingNameList) {
    state.menuUploadMissingNameList = menuUploadMissingNameList;
  },
  SET_MENU_UPLOAD_EXCEEDED_CHAR_LIMIT_LIST(
    state,
    menuUploadExceededCharLimitList
  ) {
    state.menuUploadExceededCharLimitList = menuUploadExceededCharLimitList;
  },
  SET_MENU_BULK_EDIT_SELECTION(state, menuBulkEditSelection) {
    state.menuBulkEditSelection = menuBulkEditSelection;
  },
  SET_MENU_UPLOAD_GRID_FILTERS(state, filters) {
    state.menuUploadGridFilters = { ...filters };
  }
  // SET_GROUPED_MENU(state, selectedGroupBy) {
  // if (state.selectedGroupBy !== selectedGroupBy) {
  //   state.selectedGroupBy = selectedGroupBy;
  //   console.log("start ::: getGroupedMenu", new Date());
  //   let list = [],
  //     section = {};
  //   state.groupedMenuItems = [];
  //   // add items to list
  //   if (selectedGroupBy === "batch") {
  //     try {
  //       $nuxt.$store.state.restaurant.locationDetails.location_timing.forEach(
  //         element => {
  //           section = {};
  //           section.label = element.name;
  //           section.id = element.name;
  //           section.start_time = element.start_time;
  //           section.end_time = element.end_time;
  //           section.items = state.menuItems.filter(item => {
  //             return (
  //               item.category_timing &&
  //               item.category_timing.length &&
  //               item.category_timing.find(el => {
  //                 return el == element.name;
  //               })
  //             );
  //           });
  //           state.groupedMenuItems.push(section);
  //         }
  //       );
  //     } catch (error) {
  //       state.groupedMenuItems = [];
  //     }
  //   } else if (selectedGroupBy === "category") {
  //     section = {};
  //     section.label = "All Items";
  //     section.id = "all-items";
  //     section.items = state.menuItems.filter(item => {
  //       return true;
  //     });
  //     state.groupedMenuItems.push(section);
  //     section = {};
  //     section.label = "Recommended Items";
  //     section.id = "recommended-items";
  //     section.items = state.menuItems.filter(item => {
  //       return item.recommended_item;
  //     });
  //     state.groupedMenuItems.push(section);
  //     // section = {};
  //     // section.label = "Todays Special";
  //     // section.id = "todays-special";
  //     // section.items = state.menuItems.filter(item => {
  //     //   return item.todays_special;
  //     // });
  //     // list.push(section);
  //     state.categories.forEach(element => {
  //       section = {};
  //       section.label = element.category_name;
  //       section.id = element.id;
  //       if (element.subcategories && element.subcategories.length) {
  //         section.subcategories = JSON.parse(
  //           JSON.stringify(element.subcategories)
  //         );
  //         section.subcategories.forEach((subcategory, index) => {
  //           section.subcategories[index].items = state.menuItems.filter(
  //             item => {
  //               return item.sub_category_id == subcategory.id;
  //             }
  //           );
  //         });
  //       }
  //       section.items = state.menuItems.filter(item => {
  //         return item.category_id == element.id && !item.sub_category_id;
  //       });
  //       state.groupedMenuItems.push(section);
  //     });
  //   } else if (selectedGroupBy === "dish") {
  //     this.$constants.dishTypes.DISH_TYPES.forEach(element => {
  //       section = {};
  //       section.label = element.label;
  //       section.id = element.value;
  //       section.items = state.menuItems.filter(item => {
  //         return item.dish_type.includes(element.value);
  //       });
  //       state.groupedMenuItems.push(section);
  //     });
  //   } else if (selectedGroupBy === "charges") {
  //     state.otherCharges.forEach(element => {
  //       section = {};
  //       section.label = element.label;
  //       section.id = element.value;
  //       section.items = state.menuItems.filter(item => {
  //         return (
  //           item.additional_charges.find(el => {
  //             return el.name == element.value;
  //           }) && true
  //         );
  //       });
  //       state.groupedMenuItems.push(section);
  //     });
  //     state.taxes.forEach(element => {
  //       section = {};
  //       section.label = element.tax_name;
  //       section.id = element.id;
  //       section.items = state.menuItems.filter(item => {
  //         return item.zomato_tax_id.includes(element.id);
  //       });
  //       state.groupedMenuItems.push(section);
  //     });
  //   } else if (selectedGroupBy === "tags") {
  //     state.tags.forEach(element => {
  //       section = {};
  //       section.label = element.name;
  //       section.id = element.id;
  //       section.items = state.menuItems.filter(item => {
  //         return item.tags.includes(element.name);
  //       });
  //       state.groupedMenuItems.push(section);
  //     });
  //   }
  //   // sort list
  //   if (list && list.length) {
  //     list.forEach((section, index) => {
  //       if (state.sortOrder == "alphabetical-order") {
  //         list[index].items = section.items.sort((a, b) =>
  //           a.item_name < b.item_name ? -1 : Number(a.item_name > b.item_name)
  //         );
  //       } else if (state.sortOrder == "time-added") {
  //         list[index].items = section.items.sort((a, b) => a.id - b.id);
  //       } else if (state.sortOrder == "price-low-to-high") {
  //         list[index].items = section.items.sort(
  //           (a, b) =>
  //             Number(a.item_price || a.item_unit_price) -
  //             Number(b.item_price || b.item_unit_price)
  //         );
  //       } else if (state.sortOrder == "price-high-to-low") {
  //         list[index].items = section.items.sort(
  //           (a, b) =>
  //             Number(b.item_price || b.item_unit_price) -
  //             Number(a.item_price || a.item_unit_price)
  //         );
  //       }
  //     });
  //   }
  //   console.log("end ::: getGroupedMenu", new Date());
  //   // state.groupedMenuItems = list;
  // }
  // }
};

export const actions = {
  updateMenuUploadConfigureChargesFilters({ commit }, filters) {
    commit("SET_CONFIGURE_CHARGES_FILTERS", filters);
  },
  resetMenuUploadList({ commit }) {
    commit("RESET_MENU_UPLOAD_LIST");
  },
  getMenuList({ dispatch, commit, state }, forceFetch = false) {
    if (!forceFetch && state.menuItems && state.menuItems.length) return;
    const id =
      $nuxt.$ls.get("selected-location-id") || this.$route.params.location;
    // commit("SET_MENU_LOADING", true);
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`/menus/items`, {
          params: { location_id: id },
          ...$nuxt.$configData?.apiV2Config
        })
        .then(function (response) {
          commit("SET_MENU_ITEMS", response.data.items);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {
          // commit("SET_MENU_LOADING", false);
        });
    });
  },
  getMenuListForOrder(
    { dispatch, commit, state },
    { forceFetch = false, brandId } = {}
  ) {
    brandId = brandId || $nuxt.$ls.get("selected-restaurant");
    if (!forceFetch && state.menuItems && state.menuItems.length) return;
    return new Promise((resolve, reject) => {
      this.$axios
        .get(getStoreApiUrl("menu"), {
          params: { brand_id: brandId },
          ...$nuxt.$configData?.apiV2Config
        })
        .then(function (response) {
          const menuItems = response.data;
          const comboArray = menuItems.filter(
            (item) => item?.combo_items?.length
          );
          const nonComboArray = menuItems.filter(
            (item) => !item?.combo_items?.length
          );
          commit("SET_MENU_ITEMS", nonComboArray);
          commit("SET_COMBOS_LIST", comboArray);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        });
    });
  },
  getCategories({ dispatch, state, commit }, { forceFetch = false, id } = {}) {
    if (!forceFetch && state.categories && state.categories.length) return;
    if (!id) {
      id = $nuxt.$ls.get("selected-location-id");
    }
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`/menus/categories`, {
          params: { location_id: id },
          ...$nuxt.$configData?.apiV2Config
        })
        .then(function (response) {
          commit("SET_CATEGORIES", response.data);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  getTaxes({ dispatch, state, commit }, forceFetch = false) {
    if (!forceFetch && state.taxes && state.taxes.length) return;
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`/menus/taxes`, { ...$nuxt.$configData?.apiV2Config })
        .then(function (response) {
          commit("SET_TAXES", response.data.taxes);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  getTags({ dispatch, state, commit }) {
    if (state.tags && state.tags.length) return;
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`/menus/tags`, { ...$nuxt.$configData?.apiV2Config })
        .then(function (response) {
          commit("SET_TAGS", response.data.tags);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  getAddons({ dispatch, state, commit }, { forceFetch = false, id } = {}) {
    if (!forceFetch && state.addons && state.addons.length) return;
    id =
      id ||
      $nuxt.$ls.get("selected-location-id") ||
      $nuxt.$ls.get("selected-restaurant");
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`menus/addons`, {
          params: { location_id: id },
          ...$nuxt.$configData?.apiV2Config
        })
        .then(function (response) {
          commit("SET_ADDONS", response.data.addons);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  getAddonDetail({ dispatch, state, commit }, itemId) {
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`/menus/addons/${itemId}`, {
          ...$nuxt.$configData?.apiV2Config
        })
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  changeMenuItemStatus(
    { dispatch, state, commit },
    { itemId, status, shouldTurnOffCombo = false }
  ) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          `/menus/items/${itemId}/${status ? "on" : "off"}`,
          {
            disable_combos: shouldTurnOffCombo
          },
          $nuxt.$configData?.apiV2Config
        )
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  changeVariantItemStatus(
    { commit },
    { itemId, variantId, status, shouldTurnOffCombo = false }
  ) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          `/menus/variants/${variantId}/${status ? "on" : "off"}`,
          {
            disable_combos: shouldTurnOffCombo
          },
          $nuxt.$configData?.apiV2Config
        )
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  uploadImage({ dispatch, state, commit, rootState }, formData) {
    const uid = rootState.auth.user.id;
    return new Promise((resolve, reject) => {
      this.$axios
        .put(`/users/${uid}/image_upload`, formData)
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  createMenuItem({ dispatch, state, commit }, payload) {
    const id = $nuxt.$ls.get("selected-location-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          `/menus/items`,
          { location_id: id, ...payload },
          $nuxt.$configData?.apiV2Config
        )
        .then(function (response) {
          if (!state.menuItems.length) {
            dispatch("restaurant/getLocationDetails", false);
          }
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  updateMenuItem({ dispatch, state, commit }, payload) {
    return new Promise((resolve, reject) => {
      this.$axios
        .put(
          `/menus/items/${payload.item.id}`,
          payload,
          $nuxt.$configData?.apiV2Config
        )
        .then(function (response) {
          resolve(response);
          return response;
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  getMenuItem({ dispatch, state, commit }, itemId) {
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`/menus/items/${itemId}`, {
          ...$nuxt.$configData?.apiV2Config
        })
        .then(function (response) {
          commit("SET_MENU_ITEM", response.data);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  deleteMenuItem({ dispatch, state, commit }, itemId) {
    return new Promise((resolve, reject) => {
      this.$axios
        .delete(`/menus/items/${itemId}`, {
          ...$nuxt.$configData?.apiV2Config
        })
        .then(function (response) {
          commit("REMOVE_MENU_ITEM", itemId);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },

  createAddon({ dispatch, state, commit }, payload) {
    const id = $nuxt.$ls.get("selected-location-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          `/menus/addons`,
          { location_id: id, ...payload },
          $nuxt.$configData?.apiV2Config
        )
        .then(function ({ data }) {
          // commit("ADD_ADDONS", data.data);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  updateAddon({ dispatch, state, commit }, payload) {
    const id = $nuxt.$ls.get("selected-location-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .put(
          `menus/addons/${payload?.addons?.id}`,
          { location_id: id, ...payload },
          $nuxt.$configData?.apiV2Config
        )
        .then(function ({ data }) {
          // commit("ADD_ADDONS", data.data);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  deleteAddon({ dispatch, state, commit }, itemId) {
    return new Promise((resolve, reject) => {
      this.$axios
        .delete(`/menus/addons/${itemId}`, {
          ...$nuxt.$configData?.apiV2Config
        })
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },

  createCategory({ dispatch, state, commit }, payload) {
    const id = $nuxt.$ls.get("selected-location-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          `/menus/categories`,
          { location_id: id, ...payload },
          $nuxt.$configData?.apiV2Config
        )
        .then(function ({ data }) {
          // commit("ADD_ADDONS", data.data);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  updateCategory({ dispatch, state, commit }, payload) {
    return new Promise((resolve, reject) => {
      this.$axios
        .put(
          `/menus/categories/${payload?.id}`,
          payload,
          $nuxt.$configData?.apiV2Config
        )
        .then(function ({ data }) {
          // commit("ADD_ADDONS", data.data);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  deleteCategory({ dispatch, state, commit }, itemId) {
    return new Promise((resolve, reject) => {
      this.$axios
        .delete(`/menus/categories/${itemId}`, {
          ...$nuxt.$configData?.apiV2Config
        })
        .then(function (response) {
          dispatch("getMenuList", true);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  createSubCategory({ dispatch, state, commit }, { payload }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post(`/menus/sub_categories`, payload, $nuxt.$configData?.apiV2Config)
        .then(function ({ data }) {
          // commit("ADD_ADDONS", data.data);
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  updateSubCategory({ dispatch, state, commit }, { payload }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .put(
          `/menus/sub_categories/${payload?.id}`,
          payload,
          $nuxt.$configData?.apiV2Config
        )
        .then(function ({ data }) {
          resolve(data);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  deleteSubCategory({ dispatch, commit }, { categoryId, subCategoryId }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .delete(`/menus/sub_categories/${subCategoryId}`, {
          ...$nuxt.$configData?.apiV2Config
        })
        .then(function (response) {
          dispatch("getMenuList", true);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  availabilitySync({ commit }, payload) {
    const location_id = $nuxt.$ls.get("selected-location-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          `/menus/publish_toggle_status`,
          { location_id, ...payload },
          $nuxt.$configData?.apiV2Config
        )
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  catalogueSync({ commit }) {
    const location_id = $nuxt.$ls.get("selected-location-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          `/menus/publish_catalogue`,
          { location_id },
          $nuxt.$configData?.apiV2Config
        )
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  getSyncStatus({ commit }) {
    const id = $nuxt.$ls.get("selected-location-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`/locations/${id}/sync_status`, {
          ...$nuxt.$configData?.apiV2Config
        })
        .then(function (response) {
          commit("SET_SYNC_STATUS", response.data?.menu_sync_status);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  updateTiming({ commit }, payload) {
    const id = $nuxt.$ls.get("selected-restaurant-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .post(`/restaurants/${id}/update-timing`, payload)
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  getCombosList({ commit }, forceFetch = false) {
    if (!forceFetch && state.combosList && state.combosList.length) return;
    const id = $nuxt.$ls.get("selected-location-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`/menus/combos`, {
          params: { location_id: id },
          ...$nuxt.$configData?.apiV2Config
        })
        .then(function (response) {
          commit("SET_COMBOS_LIST", response.data);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  getCombosDetail({ commit }, comboId) {
    return new Promise((resolve, reject) => {
      this.$axios
        .get(`/menus/combos/${comboId}`, {
          ...$nuxt.$configData?.apiV2Config
        })
        .then(function (response) {
          commit("SET_COMBOS_DETAIL", response.data?.data);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  createCombo({ commit }, payload) {
    const id = $nuxt.$ls.get("selected-location-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          `/menus/combos`,
          { location_id: id, ...payload },
          $nuxt.$configData?.apiV2Config
        )
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  updateCombo({ commit }, { payload, comboId }) {
    const id = $nuxt.$ls.get("selected-location-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .put(
          `/menus/combos/${comboId}`,
          payload,
          $nuxt.$configData?.apiV2Config
        )
        .then(function (response) {
          commit("SET_COMBOS_DETAIL", response.data?.data);
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  deleteCombo({ commit }, comboId) {
    return new Promise((resolve, reject) => {
      this.$axios
        .delete(`/menus/combos/${comboId}`, {
          ...$nuxt.$configData?.apiV2Config
        })
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  changeComboItemStatus({ dispatch, state, commit }, { itemId, status }) {
    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          `/menus/combos/${itemId}/${status ? "on" : "off"}`,
          {},
          $nuxt.$configData?.apiV2Config
        )
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  menuBulkUpload({ commit }, items) {
    const id = $nuxt.$ls.get("selected-location-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          `/menus/bulk_upload_v2`,
          { location_id: id, items },
          $nuxt.$configData?.apiV2Config
        )
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  menuGetAssistance({ commit }, payload) {
    const id = $nuxt.$ls.get("selected-location-id");
    return new Promise((resolve, reject) => {
      this.$axios
        .post(
          `/locations/${id}/menu_assistance`,
          payload,
          $nuxt.$configData?.apiV2Config
        )
        .then(function (response) {
          resolve(response);
        })
        .catch((err) => {
          reject(err);
        })
        .finally(() => {});
    });
  },
  updateMenuUploadGridFilters({ commit }, filters) {
    commit("SET_MENU_UPLOAD_GRID_FILTERS", filters);
  },
  resetFilters({ commit }) {
    const defaultFilters = {
      displayWithout: true,
      displayWith: true,
      categorizedView: true,
      isImageView: false
    };
    commit("SET_MENU_UPLOAD_GRID_FILTERS", defaultFilters);
  },
  resetMenuBulkUploadStore({ commit }) {
    commit("SET_MENU_UPLOAD_CURRENT_STEP", 0);
    commit("SET_MENU_UPLOAD_RAW_DATA", []);
    commit("SET_MENU_UPLOAD_LIST", []);
    commit("SET_MENU_UPLOAD_IMAGES", []);
    commit("SET_MENU_UPLOAD_FIELD_MAP", []);
  }
};

export const getters = {
  getConfiguredChargesFilteredItems(state) {
    const {
      withPackagingCharges,
      withoutPackagingCharges,
      withVariants,
      withoutVariants
    } = state.menuUploadConfigureChargesFilters;

    if (
      withVariants === true &&
      withoutVariants === true &&
      withPackagingCharges === true &&
      withoutPackagingCharges === true
    ) {
      return state.menuUploadList;
    }

    const hasPackageCharge = (item) =>
      item.package_charge !== undefined &&
      item.package_charge !== null &&
      item.package_charge !== 0;

    const hasVariants = (item) => item.variants && item.variants.length > 0;

    // Filter items based on selected filters
    return state.menuUploadList.filter((item) => {
      let packageChargeCondition = true;
      let variantsCondition = true;

      if (withPackagingCharges || withoutPackagingCharges) {
        packageChargeCondition =
          (withPackagingCharges && hasPackageCharge(item)) ||
          (withoutPackagingCharges && !hasPackageCharge(item));
      }

      if (withVariants || withoutVariants) {
        variantsCondition =
          (withVariants && hasVariants(item)) ||
          (withoutVariants && !hasVariants(item));
      }

      return packageChargeCondition && variantsCondition;
    });
  },
  getItemsWithMandatoryButUnassignedDescriptions(state) {
    const keyWords = ["combo", "meals", "group", "platter", "box", "thali"];
    const keywordItems = state.menuUploadList.filter((item) =>
      keyWords.some((keyword) => item.item_name.toLowerCase().includes(keyword))
    );

    const mandatoryItems = keywordItems.filter((item) => {
      return !item.description || item.description.trim() === "";
    });
    return mandatoryItems;
  },
  getPendingAvailabilitySyncItems(state) {
    return (
      state.menuItems?.filter((item) => {
        return item.pending_availability_sync;
      }) || []
    );
  },
  getPendingCatalogueSyncItems(state) {
    return (
      state.menuItems?.filter((item) => {
        return item.pending_catalogue_sync;
      }) || []
    );
  },
  getPendingAvailabilitySyncVariantItems(state) {
    let variants = [];
    state.menuItems?.forEach((item) => {
      if (item.variants && item.variants.items && item.variants.items.length) {
        const found = item.variants.items.filter((el) => {
          return el.pending_availability_sync;
        });
        if (found && found.length) {
          variants.push(...found);
        }
      }
    });
    return variants;
  },
  getPendingCatalogueSyncVariantItems(state) {
    let variants = [];
    state.menuItems?.forEach((item) => {
      if (item.variants && item.variants.items && item.variants.items.length) {
        const found = item.variants.items.filter((el) => {
          return el.pending_catalogue_sync;
        });
        if (found && found.length) {
          variants.push(...found);
        }
      }
    });
    return variants;
  },
  getPendingAvailabilitySyncAddons(state) {
    return state.addons?.filter((item) => {
      return item.pending_availability_sync;
    });
  },
  getPendingCatalogueSyncAddons(state) {
    return (
      state.addons?.filter((item) => {
        return item.pending_catalogue_sync;
      }) || []
    );
  },
  getPendingAvailabilitySyncCombos(state) {
    return state.combosList?.filter((item) => {
      return item.pending_availability_sync;
    });
  },
  getPendingCatalogueSyncCombos(state) {
    return (
      state.combosList?.filter((item) => {
        return item.pending_catalogue_sync;
      }) || []
    );
  },
  isMenuSyncPending(state) {
    return state.syncStatus === "pending";
  },

  getGroupedMenu(state) {
    // return function(selectedGroupBy) {
    const selectedGroupBy = state.selectedGroupBy;
    console.log("start ::: getGroupedMenu", new Date());
    let list = [],
      menuItems = [],
      section = {};
    if (state.brandFilter === "all-brands") {
      menuItems = state.menuItems?.map((el) => el);
    } else {
      menuItems = state.menuItems?.filter((item) =>
        item?.restaurant_ids?.some((el) => el === state.brandFilter)
      );
    }
    // add items to list
    if (selectedGroupBy === "batch") {
      try {
        $nuxt.$store.state.restaurant.locationDetails.location_timing.forEach(
          (element) => {
            section = {};
            section.label = element.name;
            section.id = element.name;
            section.start_time = element.start_time;
            section.end_time = element.end_time;
            section.items = menuItems?.filter((item) => {
              return (
                item.category_timing &&
                item.category_timing.length &&
                item.category_timing.find((el) => {
                  return el == element.name;
                })
              );
            });
            list.push(section);
          }
        );
      } catch (error) {
        list = [];
      }
    } else if (selectedGroupBy === "category") {
      section = {};
      section.label = "All Items";
      section.id = "all-items";
      section.items = [...menuItems, ...state.combosList];
      list.push(section);
      section = {};
      section.label = "Recommended Items";
      section.id = "recommended-items";
      section.items = menuItems.filter((item) => {
        return item.recommended_item;
      });
      list.push(section);

      section = {};
      section.label = "Combos";
      section.id = "combos";
      section.items = [...state.combosList];
      list.push(section);

      // section = {};
      // section.label = "Todays Special";
      // section.id = "todays-special";
      // section.items = menuItems.filter(item => {
      //   return item.todays_special;
      // });
      // list.push(section);
      state.categories?.forEach((element) => {
        section = {};
        section.label = element.category_name;
        section.id = element.id;
        if (element.subcategories && element.subcategories.length) {
          section.subcategories = JSON.parse(
            JSON.stringify(element.subcategories)
          );
          section.subcategories.forEach((subcategory, index) => {
            section.subcategories[index].items = menuItems.filter((item) => {
              return item.sub_category_id == subcategory.id;
            });
          });
        }
        section.items = menuItems.filter((item) => {
          return item.category_id == element.id && !item.sub_category_id;
        });
        list.push(section);
      });
    } else if (selectedGroupBy === "dish") {
      $nuxt.$constants.dishTypes.DISH_TYPES.forEach((element) => {
        section = {};
        section.label = element.label;
        section.id = element.value;
        section.items = menuItems.filter((item) => {
          return item.dish_type.includes(element.value);
        });
        list.push(section);
      });
    } else if (selectedGroupBy === "charges") {
      state.otherCharges.forEach((element) => {
        section = {};
        section.label = element.label;
        section.id = element.value;
        section.items = menuItems.filter((item) => {
          return (
            item.additional_charges.find((el) => {
              return el.name == element.value;
            }) && true
          );
        });
        list.push(section);
      });
      state.taxes.forEach((element) => {
        section = {};
        section.label = element.tax_name;
        section.id = element.id;
        section.items = menuItems.filter((item) => {
          return item.zomato_tax_id?.includes(element.id);
        });
        list.push(section);
      });
    } else if (selectedGroupBy === "tags") {
      state.tags.forEach((element) => {
        section = {};
        section.label = element.name;
        section.id = element.id;
        section.items = menuItems.filter((item) => {
          return item.tags.includes(element.name);
        });
        list.push(section);
      });
    }
    // sort list
    if (list && list.length) {
      list.forEach((section, index) => {
        if (state.sortOrder == "alphabetical-order") {
          list[index].items = section.items.sort((a, b) =>
            a.item_name < b.item_name ? -1 : Number(a.item_name > b.item_name)
          );
        } else if (state.sortOrder == "time-added") {
          list[index].items = section.items.sort((a, b) => a.id - b.id);
        } else if (state.sortOrder == "price-low-to-high") {
          list[index].items = section.items.sort(
            (a, b) =>
              Number(a.item_price || a.item_unit_price) -
              Number(b.item_price || b.item_unit_price)
          );
        } else if (state.sortOrder == "price-high-to-low") {
          list[index].items = section.items.sort(
            (a, b) =>
              Number(b.item_price || b.item_unit_price) -
              Number(a.item_price || a.item_unit_price)
          );
        }
      });
    }
    console.log("start ::: getGroupedMenu", new Date());
    return list;
    // };
  },
  getSoldOutList(state) {
    return state.menuItems.filter((item) => {
      return item.item_is_active == 0;
    });
  },
  getCategoryObj(state) {
    return function (id) {
      return state.categories.find((item) => {
        return item.id == id;
      });
    };
  },
  getPrinterUnassignedItems(state) {
    return state.menuItems?.filter((item) => {
      return !item.printer_id;
    });
  },
  getPrinterAssignedItems(state) {
    return function (id) {
      return state.menuItems?.filter((item) => {
        return item.printer_id == id;
      });
    };
  },
  getMenuUploadItemsByProp(state) {
    return function (propName, propValue) {
      return state.menuUploadList.filter((item) => {
        return !propValue ? !item[propName] : item[propName] === propValue;
      });
    };
  },
  getMenuUploadList(state) {
    return state.menuUploadList;
  },
  getEnableDisableItems(
    {},
    {
      getPendingAvailabilitySyncItems,
      getPendingAvailabilitySyncVariantItems,
      getPendingAvailabilitySyncAddons,
      getPendingAvailabilitySyncCombos
    }
  ) {
    let enable = { items: [], options: [], combos: [] },
      disable = { items: [], options: [], combos: [] };
    if (getPendingAvailabilitySyncItems?.length) {
      getPendingAvailabilitySyncItems.forEach((item) => {
        if (item.item_is_active == 1) {
          enable.items.push(item.id);
        } else {
          disable.items.push(item.id);
        }
      });
    }
    if (getPendingAvailabilitySyncVariantItems?.length) {
      getPendingAvailabilitySyncVariantItems.forEach((item) => {
        if (item.is_active == 1 || item.item_is_active == 1) {
          enable.options.push(`v-${item.id}`);
        } else {
          disable.options.push(`v-${item.id}`);
        }
      });
    }
    if (getPendingAvailabilitySyncAddons?.length) {
      getPendingAvailabilitySyncAddons.forEach((item) => {
        if (item.item_is_active == 1) {
          enable.options.push(`a-${item.id}`);
        } else {
          disable.options.push(`a-${item.id}`);
        }
      });
    }
    if (getPendingAvailabilitySyncCombos?.length) {
      getPendingAvailabilitySyncCombos.forEach((item) => {
        if (item.is_active) {
          enable.combos.push(item.id);
        } else {
          disable.combos.push(item.id);
        }
      });
    }
    return { enable, disable };
  },
  syncPendingTotalCount(
    {},
    {
      getPendingAvailabilitySyncItems,
      getPendingAvailabilitySyncVariantItems,
      getPendingAvailabilitySyncAddons,
      getPendingAvailabilitySyncCombos,
      getPendingCatalogueSyncItems,
      getPendingCatalogueSyncVariantItems,
      getPendingCatalogueSyncAddons,
      getPendingCatalogueSyncCombos
    }
  ) {
    return (
      (getPendingAvailabilitySyncItems?.length || 0) +
      (getPendingAvailabilitySyncVariantItems?.length || 0) +
      (getPendingAvailabilitySyncAddons?.length || 0) +
      (getPendingCatalogueSyncItems?.length || 0) +
      (getPendingCatalogueSyncVariantItems?.length || 0) +
      (getPendingCatalogueSyncAddons?.length || 0) +
      (getPendingAvailabilitySyncCombos?.length || 0) +
      (getPendingCatalogueSyncCombos?.length || 0)
    );
  },
  isAvailabilitySyncPending(
    {},
    {
      getPendingAvailabilitySyncItems,
      getPendingAvailabilitySyncVariantItems,
      getPendingAvailabilitySyncAddons,
      getPendingAvailabilitySyncCombos
    }
  ) {
    return (
      getPendingAvailabilitySyncItems?.length ||
      getPendingAvailabilitySyncVariantItems?.length ||
      getPendingAvailabilitySyncAddons?.length ||
      getPendingAvailabilitySyncCombos?.length
    );
  },
  isCatalogueSyncPending(
    {},
    {
      isMenuSyncPending,
      getPendingCatalogueSyncItems,
      getPendingCatalogueSyncVariantItems,
      getPendingCatalogueSyncAddons,
      getPendingCatalogueSyncCombos
    }
  ) {
    return (
      isMenuSyncPending ||
      getPendingCatalogueSyncItems?.length ||
      getPendingCatalogueSyncVariantItems?.length ||
      getPendingCatalogueSyncAddons?.length ||
      getPendingCatalogueSyncCombos?.length
    );
  },
  getMenuUploadListGroupByCategory(state) {
    return state.categories
      .map((category) => {
        return {
          id: category.category_id,
          name: category.category_name,
          items: state.menuUploadList.filter((item) => {
            return item.category_id == category.category_id;
          })
        };
      })
      .filter((el) => el.items.length);
  },

  getFilteredBulkUploadItems(state) {
    return function (id) {
      const { displayWith, displayWithout, categorizedView } =
        state.menuUploadGridFilters;

      const filterItems = (items, condition) => items.filter(condition);

      const applyFilter = (items, condition) => {
        if (displayWith && displayWithout) return items;
        if (displayWith) return filterItems(items, condition);
        if (displayWithout)
          return filterItems(items, (item) => !condition(item));
        return [];
      };

      const getCondition = () => {
        switch (id) {
          case "add-photos":
            return (item) =>
              state.menuUploadImageList.some((el) => el.itemId == item.id);
          case "add-description":
            return (item) => !!item.description;
          case "set-addons":
            return (item) => !!item.addons?.length;
          case "set-choices":
            return (item) => !!item.choices?.length;
          default:
            return () => true;
        }
      };

      const filteredItems = applyFilter(state.menuUploadList, getCondition());

      if (categorizedView) {
        return state.categories
          .map((category) => ({
            id: category.category_id,
            name: category.category_name,
            items: filteredItems.filter(
              (item) => item.category_id == category.category_id
            )
          }))
          .filter((el) => el.items.length);
      }

      return filteredItems;
    };
  },
  getItemsWithoutPrice(state) {
    return state.menuUploadList.filter((item) => {
      const hasNoPrice = !item.price || item.price <= 0 || isNaN(item.price);
      const hasNoVariants = !item.variants || item.variants.length === 0;
      return hasNoPrice && hasNoVariants;
    });
  }
};
